"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./get-page-context"), exports);
tslib_1.__exportStar(require("./add-page-context"), exports);
//# sourceMappingURL=index.js.map